import { useEffect, useState } from 'react';
import { api } from './api.js';
import { stamp } from './format.js';

/**
 * Enquiries from imtlogic.com.
 *
 * Visible only to an administrator of the platform's own tenant — the server enforces that,
 * this only decides whether to draw the tab. Unhandled first, because the whole point of a
 * list like this is that nothing sits in it for a week without somebody noticing.
 */

const WANTS = {
  tabletop: 'Tabletop exercise',
  demo: 'Demonstration',
  question: 'General question',
};

export function Enquiries() {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);

  async function load() {
    try { setRows((await api.enquiries()).enquiries); }
    catch { setError('Could not load the enquiries.'); }
  }
  useEffect(() => { load(); }, []);

  async function mark(row, handled) {
    setError(null);
    try { await api.setEnquiryHandled(row.id, handled); await load(); }
    catch { setError('That did not save.'); }
  }

  if (error && !rows) return <div className="card"><div className="empty">{error}</div></div>;
  if (!rows) return <div className="card"><div className="empty">Loading…</div></div>;

  const open = rows.filter((r) => !r.handled_at).length;

  return (
    <div className="card">
      <h2>
        Enquiries
        <span className="n muted">{open} not yet dealt with</span>
      </h2>

      {error && <p className="err inline">{error}</p>}

      <div className="body">
        {rows.length === 0 && <div className="empty">Nothing has come in yet.</div>}

        {rows.length > 0 && (
          <table className="grid">
            <thead>
              <tr>
                <th>Came in</th><th>Who</th><th>Wants</th><th>Sector</th>
                <th>Message</th><th className="right" />
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className={r.handled_at ? 'closed' : ''}>
                  <td className="nowrap dimmed">{stamp(r.created_at)}</td>
                  <td>
                    <div>{r.name}</div>
                    {r.organisation && <div className="sub">{r.organisation}</div>}
                    {/* mailto rather than plain text: the next thing anybody does with this
                        screen is reply, and making them copy an address by hand is a
                        transcription error waiting to happen. */}
                    <a className="mail" href={`mailto:${r.email}`}>{r.email}</a>
                  </td>
                  <td>{WANTS[r.wants] || r.wants}</td>
                  <td className="dimmed">{r.sector}</td>
                  <td className="msgcell">{r.message || <span className="dimmed">—</span>}</td>
                  <td className="right nowrap">
                    <button className="linkbtn small" onClick={() => mark(r, !r.handled_at)}>
                      {r.handled_at ? 'reopen' : 'mark dealt with'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
